import { toast } from 'sonner'

import api from '@/services/api'

interface GenerateUrlProps {
  value: string
  testId?: string
}
export async function generateUrl({ value, testId }: GenerateUrlProps) {
  await api
    .get(value, { responseType: 'blob' })
    .then(({ data }) => {
      const url = window.URL.createObjectURL(data)
      window.open(url, '_blank')
    })
    .catch((error) => {
      toast.error(error.response?.data?.message || 'Erro ao gerar url', {
        className: testId,
      })
    })
}
